import "@theme/front/init.scss";

import "bootstrap-front/js/dist/tooltip";
import "bootstrap-front/js/dist/dropdown";
import "bootstrap-front/js/dist/collapse";
import "bootstrap-front/js/dist/modal";

import "nette.ajax.js";

import "@mdi/font/css/materialdesignicons.min.css";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "owl.carousel";

import AutoComplete from "autocomplete-js";
import "autocomplete-js/dist/autocomplete.css";

import "lightbox2/dist/css/lightbox.css";
import lightbox from "lightbox2/dist/js/lightbox";

import {initScroll} from "@/front/scroll";
import "@/front/alert";
import "@/front/addToCart";
import "@/front/cart";
import "@/front/cookie";

import Nette from "@/front/netteForms";
Nette.initOnLoad();
window.Nette = Nette;

document.addEventListener("DOMContentLoaded", () => {
	$.nette.init();

	const isSmallScreen = window.innerWidth <= 768;
	const elements = document.querySelectorAll('.item-' + (isSmallScreen ? 'lg' : 'sm'));
	elements.forEach(element => element.remove());

	$(document.querySelector('.owl-carousel')).owlCarousel({
		items: 1,
		loop: true,
		autoplay: true,
		autoplayTimeout: 3000,
		autoplayHoverPause: true,
		nav: true,
		navText: [
			'<i class="mdi mdi-arrow-left-thick"></i>',
			'<i class="mdi mdi-arrow-right-thick"></i>'
		],
		dots: true,
	});

	lightbox.option({
		wrapAround: true,
		showImageNumberLabel: false
	});

	$("[data-toggle='tooltip']").tooltip({
		container: "body",
		delay: {show: 0, hide: 100}
	});

	if (window.innerWidth < 768) {
		$("#category-subcategories-collapse").removeClass("show");
		$("#category-parameters-collapse").removeClass("show");
	}

	if (window.app.searchUrl && window.app.productPageUrl) {
		AutoComplete({
			Url: window.app.searchUrl,
			MinChars: 3,
			QueryArg: "product-search",
			_Render: function (response) {
				if (this.DOMResults.hasChildNodes()) {
					this.DOMResults.removeChild(this.DOMResults.childNodes[0]);
				}
				var ul = document.createElement("div");

				if (response === "") {
					var div = document.createElement("div");
					div.classList.add("bg-danger", "text-white", "dropdown-item", "text-center", "p-3");
					div.innerHTML = "Žádný produkt neodpovídá zadaným kritériím!";

					ul.appendChild(div);
				} else {
					const items = JSON.parse(response);

					for (var key in items) {
						if (!items.hasOwnProperty(key)) continue;

						var a = document.createElement("a");
						var item = items[key];

						a.classList.add("dropdown-item");
						a.href = window.app.productPageUrl + "/" + item.slug;
						a.title = item.name;

						if (item.image) {
							a.innerHTML = "<img src='/upload/product/" + item.id + "/" + item.image + "' />" + item.name;
						} else {
							a.innerHTML = item.name;
						}

						ul.appendChild(a);
					}

					a = document.createElement("a");

					a.classList.add("dropdown-item", "bg-primary", "text-white", "px-3", "py-2", "form-search-toggle", "cursor-pointer");
					a.innerHTML = "<i class='mdi mdi-magnify mdi-scale-1-3'></i>&nbsp;&nbsp;Zobrazit vše";

					ul.appendChild(a);
				}

				this.DOMResults.appendChild(ul);

				$(".form-search-toggle").off("click").on("click", function () {
					$(this).closest("form").submit();
				});
			},
			_Blur: function () {
				setTimeout(function () {
					this.DOMResults.setAttribute("class", "autocomplete");
				}.bind(this), 150);
			}
		}, ".form-search-autocomplete");
	}

	const navbar = $(".navbar");

	$(".navbar-toggler").off("click").on("click", function () {
		const isShown = $(this).hasClass("collapsed");

		if (isShown) {
			navbar.addClass("navbar-shown").css("bottom", 0);
		} else {
			navbar.removeClass("navbar-shown");
			setTimeout(function () {
				navbar.css("bottom", "");
			}, 300);
		}
	});

	$(".nav-main").on("hidden.bs.collapse", function () {
		$(".nav-search").collapse("show");
		$(".nav-search").find(".form-control").focus();
	});

	$(".nav-search").on("hidden.bs.collapse", function () {
		$(".nav-main").collapse("show");
	});

	$(".nav-search-toggle").off("click").on("click", function () {
		if ($(".nav-main").hasClass("show")) {
			$(".nav-main").collapse("hide");
		} else {
			if ($(".nav-search").hasClass("show")) {
				$(".nav-search").collapse("hide");
			}
		}
	});

	window.addEventListener("scroll", function () {
		processNavbarScrolled();
	});

	processNavbarScrolled();
	initScroll();

	$.nette.ext("closeModalOnAjax", {
		success: function () {
			$(".hide-on-ajax").modal("hide");
		}
	});
});

function processNavbarScrolled() {
	const navbar = $(".navbar");

	if (window.scrollY > 50) {
		navbar.addClass("navbar-scrolled");
	} else {
		navbar.removeClass("navbar-scrolled");
	}
}
